import React from 'react';

const colorVariables = {
  primary: {
    primary: '#000000',
    charcoal: '#242424',
    mine: '#3b3b3b',
    chicago: '#636363',
    dawn: '#a3a3a3',
    alto: '#cccccc',
    mercury: '#e1e1e1',
    smoke: '#f2f2f2',
    white: '#ffffff',
  },
  alert: {
    'alert-light': '#ffebee',
    'alert-medium': '#b00020',
    'alert-dark': '#740031',
  },
  highlight: {
    'highlight-light': '#f1e8dd',
    'highlight-medium': '#ceb18f',
    'highlight-dark': '#826646',
  },
  success: {
    'success-light': '#d8e1d5',
    'success-medium': '#758e6d',
    'success-dark': '#3c4b37',
  },
  accent: {
    'accent-light': '#d7ddeb',
    'accent-medium': '#7183b0',
    'accent-dark': '#384669',
  },
  misc: {
    sand: '#e0d7d1',
  },
};

const ColorsList = () => {
  return (
    <div className="items">
      <div>
        <p className="editorial-large semibold mb-md">
          Color Variables (
          <a
            className="editorial-large semibold underline"
            href="https://www.figma.com/design/6xudIyDqmcUDdRu0OZxjQP/GLOW-UI?node-id=18936-880&t=u1Volg6SHkGPX5MG-4"
          >
            Reference
          </a>
          )
        </p>
        <p className="caption mb-xl">
          All colors are available as CSS variables, E.g.:{' '}
          <code className="code-example">background-color: var(--alert-light);</code>
        </p>
      </div>
      <div className="section section-wrap">
        <>
          {Object.entries(colorVariables).map(([category, colors]) => {
            const lightColors = [
              'alto',
              'mercury',
              'smoke',
              'white',
              'alert-light',
              'highlight-light',
              'success-light',
              'accent-light',
              'sand',
            ];
            return (
              <div key={category} className="color-category">
                <h3 className="h3">{category}</h3>
                {Object.entries(colors).map(([key, value]) => {
                  return (
                    <div
                      key={key}
                      className="palette body-small"
                      style={{
                        backgroundColor: `var(--${key})`,
                        color: lightColors.includes(key) ? 'var(--primary)' : 'var(--white)',
                        border: key === 'white' ? '1px solid var(--mercury)' : 'none',
                      }}
                    >
                      <span>--{key}:</span> <span style={{ textTransform: 'uppercase' }}>{value}</span>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </>
      </div>
    </div>
  );
};

export default ColorsList;
